<style lang="scss">
  header {
    position: relative;
    max-width: 100%;
    h2 {
      position: relative;
      z-index: 1;
      margin: 0 0 45px 0;
      text-align: left;
      font-size: 18px;
      font-weight: 600;
    }
    span {
      position: absolute;
      top: -80px;
      left: 30px;
      z-index: 0;
      line-height: 204px;
      font-size: 204px;
      font-weight: 600;
      color: #F2F2F2;
    }
    .headerBtns {
      margin-bottom: 20px;
      z-index: 3;
      .btn {
        font-weight: 600;
        background-color: #fff;
        -webkit-box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
        box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
        &:not(.dropdown) {
          position: absolute;
          top: -8px;
          right: 0;
          z-index: 3;
          width: 120px;
        }
        &:hover {
          color: #fff;
          background-color: #B9DD64;
        }
        &.dropdown {
          width: 140px;
          padding-right: 10px;
          padding-left: 10px;
        }
        &.dropdown:hover {
          color: #232323;
          background-color: #fff;
        }
        &.dropdown:focus {
          color: #232323;
          background-color: #fff;
          -webkit-box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
          box-shadow: 0 0 30px 0 rgba(0,0,0,.1);
        }
      }
      .btn+.btn {
        margin-left: 15px;
      }
    }
    @media (max-width: 576px) {
      .headerBtns {
        .btn.dropdown {
          display: block;
          width: 100%;
          margin: 0 0 5px 0;
        }
      }
    }
    @media (min-width: 768px) {
      h2 {
        margin-bottom: 45px !important;
      }
      .headerBtns {
        position: absolute;
        top: -8px;
        right: 0;
      }
    }
  }
</style>
<template>
  <header>
    <h2>{{title}}</h2>
    <span>{{title}}</span>
    <div class="headerBtns">
      <a v-if="url !== ''" v-bind:href="url" class="btn">Összes</a>
      <select v-if="order" name="autor" class="dropdown btn" @change="orderByAuthorChange" v-model="author">
        <option :value="null">Szerző</option>
        <option value="ASC">Szerző: A-Z</option>
        <option value="DESC">Szerző: Z-A</option>
      </select>
      <select v-if="order" name="price" class="dropdown btn" @change="orderByPriceChange" v-model="price">
        <option :value="null">Ár</option>
        <option value="ASC">Ár: növekvő</option>
        <option value="DESC">Ár: csökkenő</option>
      </select>
      <select v-if="cats.length > 0" @change="catChange()" v-model="catUrl" class="dropdown btn">
        <option :value="'/konyvek'">Összes</option>
        <option v-for="(catItem, index) in cats" :key="index" v-bind:value="catItem.url">{{catItem.name}}</option>
      </select>
    </div>
  </header>
</template>

<script>
export default {
  name: 'FrontendBooklistHeader',
  props: {
    title: { type: String },
    url: { type: String },
    order: { type: Boolean },
    cats: { type: Array },
    activeCat: { type: String }
  },
  data: function () {
    return {
      catUrl: '',
      author: null,
      price: null
    }
  },
  created: function () {
    this.catUrl = this.activeCat
  },
  methods: {
    catChange: function () {
      this.$router.push(this.catUrl)
      this.$emit('cat-change')
    },
    orderByAuthorChange: function () {
      this.$emit('authorChange', this.author)
    },
    orderByPriceChange: function () {
      this.$emit('priceChange', this.price)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/partials/booklistheader.vue